export default __webpack_public_path__ + "static/media/appel.92a2e250.png";